/* eslint-disable */
import React, { FC } from 'react';
import Downshift from 'downshift';
import injectSheet from 'react-jss';
import styleSheet from './styles';
import { Button } from '../Buttons';

interface Props {
  top?: string;
  width?: string;
  classes?: any;
  items: any;
  defaultValue?: any;
  ariaLabel: string;
  onChange?: (e: object) => void;
  indicator?: any;
  indicatorStyles?: any;
  fill?: string;
}

const Menu: FC<Props> = props => {
  const [selectedOption, setOption] = React.useState(
    props.defaultValue ? props.defaultValue.label : null
  );

  const onChange = (selected: { label: string; value: string }) => {
    setOption(selected.label);
    let response = {
      target: {
        ...selected,
      }
    }
    props.onChange ? props.onChange(response) : null;
  };

  if (!props.items) return null;
  return (
    <Downshift
      onSelect={selected => {
        onChange(selected);
      }}
      initialSelectedItem={props.defaultValue ? props.defaultValue.value : null}
    >
      {({
        isOpen,
        getToggleButtonProps,
        getItemProps,
        highlightedIndex,
        selectedItem: dsSelectedItem,
        getLabelProps,
      }) => (
        <div className={`menu ${props.classes.wrapper}`} role="button">
          <label {...getLabelProps()} style={{ display: 'none' }}>
            {props.ariaLabel}
          </label>
          {props.indicator ? (
            <button
              className={props.classes.button}
              {...getToggleButtonProps()}
              // onFocus={(e: any) => console.log((e.target.style.opacity = 1))}
              // onBlur={(e: any) => console.log((e.target.style.opacity = 0))}
              style={
                props.indicatorStyles && {
                  width: props.indicatorStyles.width
                    ? props.indicatorStyles.width
                    : '20px',
                  opacity: isOpen ? 1 : props.indicatorStyles.opacity,
                  height: props.indicatorStyles.height
                    ? props.indicatorStyles.height
                    : 'auto',
                  borderRadius: props.indicatorStyles.borderRadius
                    ? props.indicatorStyles.borderRadius
                    : '0px',
                  backgroundColor: props.indicatorStyles.backgroundColor
                    ? props.indicatorStyles.backgroundColor
                    : 'transparent',
                  display: props.indicatorStyles.display
                    ? props.indicatorStyles.display
                    : 'block',
                  justifyContent: 'center',
                  alignItems: 'center',
                }
              }
            >
              <props.indicator
                fill={props.fill ? props.fill : '#051D39'}
                className={props.fill && props.classes.moreIcon}
              >
                {selectedOption !== '' ? selectedOption : 'Select'}
              </props.indicator>
            </button>
          ) : (
            <Button {...getToggleButtonProps()}>
              {selectedOption !== '' ? selectedOption : 'Select'}
            </Button>
          )}
          <div className={props.classes.optionsHolder}>
            {isOpen && (
              <div
                className={`menu-dropdown-test ${props.classes.dropDown}`}
                onMouseLeave={() => (isOpen = false)}
              >
                {props.items.map((item: { label: String }, index: number) => (
                  <div
                    anum={index.toString()}
                    className={props.classes.dropDownItem}
                    {...getItemProps({ key: index, index, item })}
                    style={{
                      backgroundColor:
                        highlightedIndex === index ? '#4F5B84' : 'transparent',
                    }}
                  >
                    {item.label}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </Downshift>
  );
};

export default injectSheet(styleSheet)(Menu);
